<div *ngIf="datosCargados; else loading">
    <p-table [paginator]="true" [rows]="10" [showCurrentPageReport]="true" responsiveLayout="stack"
             currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} trámites asignados"
             [rowsPerPageOptions]="[10, 25, 50]" [resizableColumns]="false" columnResizeMode="expand"
             styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }" [value]="tramitesPorProyecto">
        <ng-template pTemplate="header">
            <tr>
                <th style="width:35%">Nombre</th>
                <th style="width:15%">Fase</th>
                <th style="width:10%">Tarífa</th>
                <th style="width:25%">Estado</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tramite>
            <tr>
                <td>
                    <div class="flex align-items-center">
                        <span>{{ tramite.idTramite }} - {{ tramite.nombreTramite }}</span>
                        <div class="ml-3">
                            <app-requisitos-informacion *ngIf="tramite != null" [estadisticas]="mostrarEstadisticas(tramite)"
                            (openDialogEvent)="showDialog($event)">
                            </app-requisitos-informacion>
                        </div>
                        <div class="flex flex-row justify-content-center align-items-center gap-1">
                            <ng-container *ngIf="btnTramites">
                                <ng-container *ngTemplateOutlet="btnTramites; context: {$implicit: tramite, clickEvent: onItemClickedTramite.bind(this)}"></ng-container>
                            </ng-container>
                        </div>
                    </div>
                </td>
                <td>{{ tramite.nombreFase }}</td>
                <td>
                    {{ tramite.tarifaTramite | currency:'USD':'symbol':'1.2-2' }}
                </td>
                <td>
                    <p-tag *ngIf="tramite.tramiteEstado&&tramite.tramiteEstado.codigoEstado!=0"
                           [style]="{ 'background':tramite.tramiteEstado.color}">
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-tags text-xs"></i>
                            <span class="text-base">{{ tramite.tramiteEstado?.nombreEstado }}</span>

                        </div>
                    </p-tag>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<!--Dialog que muestra la informacion de los requisitos-->
<ng-container *ngIf="openDialog">
    <app-info-dialog-requisitos
        [visible]="openDialog"
        [tramiteStats]="informacionTramiteClicked"
        (closeDialogEvent)="closeDialog()"
        [datosCargados]="tramite.datosCargados"
        [loading]="loadingTemplate">
    </app-info-dialog-requisitos>
    <ng-template #loadingTemplate class="flex align-items-center flex-wrap">
        <div class="flex justify-content-center flex-wrap">
            <p-progressSpinner></p-progressSpinner>
        </div>
    </ng-template>
</ng-container>

